export const convertToSecond = (time: number): number => {
  return time / 1000
}
